function handleProductTbhChange(index, name, value, setInputs) {
  setInputs((prevInputs) => {
    const parsedValue = value === '' ? null : parseFloat(value);
    const updatedValue = isNaN(parsedValue) ? value : parsedValue;

    const updatedProductTbh = prevInputs.product_tbh.map((item, i) => {
      if (i !== index) return item;

      let updatedItem = { ...item, [name]: updatedValue };

      if (name === 'shape') {
        if (value === 'round') {
          updatedItem = { ...updatedItem, length: null, width: null };
        } else if (value === 'rectangular') {
          updatedItem = { ...updatedItem, diameter: null, footprint: null };
        }
      }

      return updatedItem;
    });

    const longSideLeading = updatedProductTbh.some(
      (item) =>
        item.length != null &&
        item.width != null &&
        Number(item.width) > Number(item.length)
    );

    return {
      ...prevInputs,
      product_tbh: updatedProductTbh,
      long_side_leading: longSideLeading,
    };
  });
}

export default handleProductTbhChange;
